import api from '../utils/api';

const NotificationService = {
    // Get all notifications for the current user
    getMyNotifications: async () => {
        const response = await api.get('/notifications');
        return response.data;
    },

    // Mark a specific notification as read, or 'all' to mark all
    markAsRead: async (id) => {
        const response = await api.put(`/notifications/${id}/read`);
        return response.data;
    },

    // Delete a specific notification
    deleteNotification: async (id) => {
        const response = await api.delete(`/notifications/${id}`);
        return response.data;
    },

    // Send a notification (Admin only)
    sendNotification: async (notificationData) => {
        const response = await api.post('/notifications/send', notificationData);
        return response.data;
    }
};

export default NotificationService;
